import { render, staticRenderFns } from "./LegacyArticle.vue?vue&type=template&id=51aedeaa&scoped=true"
import script from "./LegacyArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./LegacyArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LegacyArticle.vue?vue&type=style&index=0&id=51aedeaa&prod&lang=scss&scoped=true"
import style1 from "./LegacyArticle.vue?vue&type=style&index=1&id=51aedeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51aedeaa",
  null
  
)

export default component.exports